/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-09, 10:34:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:05:03
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  pendingStoreActions: [],
  isOffline: false,
  mobileMenuIsVisible: false,
  bannersList: [],
  mainComponentsVisibility: {},
  panelFooterIcons: [],
  rodoTerms: [],
  occasionZoneTilesContents: {},
  occasionZoneFormSettings: {},
};

const getters = {
  pendingStoreActions: state => state.pendingStoreActions,
  isOffline: state => state.isOffline,
  bannersList: state => state.bannersList,
  mobileMenuIsVisible: state => state.mobileMenuIsVisible,
  mainComponentsVisibility: state => state.mainComponentsVisibility,
  panelFooterIcons: state => state.panelFooterIcons,
  rodoTerms: state => state.rodoTerms,
  shouldShowRodoTerms: state => state.rodoTerms.length > 0,
  occasionZoneTilesContents: state => state.occasionZoneTilesContents,
  occasionZoneFormSettings: state => state.occasionZoneFormSettings,
};


// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/App/index.js